import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { TabBar, TabItem } from '../components';

const LandscapeProjectsEditProjectsImpactTemplate: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, projectId } = useParams();
  return (
    <div>
      <TabBar
        onSelect={(id: string | null) => {
          if (id) {
            navigate(id);
          }
        }}
        defaultSelected={location.pathname}
      >
        <TabItem
          title="Target"
          id={`/landscapes/edit/${id}/projects/add-project/${projectId}/impact`}
        />
        <TabItem
          title="Commodity"
          id={`/landscapes/edit/${id}/projects/add-project/${projectId}/impact/commodity`}
        />
        <TabItem
          title="Indicators"
          id={`/landscapes/edit/${id}/projects/add-project/${projectId}/impact/indicators`}
        />
      </TabBar>
      <main>{children}</main>
    </div>
  );
};

export default LandscapeProjectsEditProjectsImpactTemplate;
